
<script>
export default {
  name: "NotFoundView"
};
</script>

<template>
  <div>
    <h1>404 - Not Found</h1>
    <p>Lo siento, la página que estás buscando no se pudo encontrar.</p>
  </div>
</template>
<style>
</style>